export const cities = [
    {
        name: 'London',
        population: 8982000, // 8.982 m
        lat: 51.509865,
        lng: -0.118092,
        description: 'London is the capital and largest city of England and the United Kingdom. Standing on the River Thames in the south-east of England, at the head of its 50-mile (80 km) estuary leading to the North Sea, London has been a major settlement for two millennia. Londinium was founded by the Romans.',
        type: 'city',
        id: 1
    },
    {
        name: 'Madrid',
        population: 6642000, // 6.642
        lat: 40.416775,
        lng: -3.703790,
        type: 'city',
        id: 2
    },
    {
      name: 'Berlin',
      population: 3769000, // 3.769
      lat: 52.520008,
      lng: 13.404954,
      type: 'city', 
      id: 3
    },
    {
      name: 'Rome',
      population: 2873000, // 2.873
      lat: 41.902782,
      lng: 12.496366,
      type: 'city',
      id: 4
    },
    {
      name: 'Paris',
      population: 2148000, // 2.148
      lat: 48.864716,
      lng: 2.349014,
      type: 'city',
      id: 5
    },
    {
        name: 'Zurich',
        population: 402762,
        lat: 47.373878,
        lng: 8.545094,
        type: 'city',
        id: 6
    }
]

export const pointOfInterests = [
    {
        name: 'Leaning Tower of Pisa',
        lat: 43.723621,
        lng: 10.396640,
        type: 'landmark',
        id: 7
    },
    {
        name: 'Acropolis & Parthenon',
        lat: 37.970833,
        lng: 23.726110,
        type: 'landmark',
        id: 8
    },
    {
        name: 'Mosque-Cathedral of Cordoba',
        lat: 37.879631,
        lng: -4.780210,
        type: 'landmark',
        id: 9
    },
    {
        name: 'Charles Bridge',
        lat: 50.086578,
        lng: 14.410640,
        type: 'landmark',
        id: 10
    },
    {
        name: 'Chateau de Chillon',
        lat: 46.411690,
        lng: 6.930320,
        type: 'landmark', 
        id: 11
    }
]

export const bodiesOfWater = [
    {
        name: 'Lake Ohrid',
        lat: 41.047253,
        lng: 20.714722,
        type: 'lakes',
        id: 12
    }
]